import { addOriginalCase, formatPhone, interleave } from "../utility/api-utilities";
import { CelRequest, Facet, Result, PrekSchool } from "../interfaces"

// @ts-ignore
const BASE_URL = window.schoolSearchApiUrl ? window.schoolSearchApiUrl : 'https://api.cps.edu/';

const EPI_URL = '/api/'
const EnrollmentYear = (window as any).bootstrap.enrollmentYear;

// @TODO pull this into a better place
const contentId = (window as any).bootstrap.contentId;
export function getAllCelSchools() {
    return fetch(`${EPI_URL}schoolprofile/ECESchoolData?EnrollmentYear=${EnrollmentYear}`)
        .then(res => res.json())
        .then(res => addOriginalCase(res))
        .then(res => res.map(s => {
            return { ...s, type: 'cel' };
        }))
}

export function getAllEceCpsSchools() {
    return fetch(`${EPI_URL}schoolprofile/ECECPSSchoolData?EnrollmentYear=${EnrollmentYear}`)
        .then(res => res.json())
        .then(res => addOriginalCase(res))
        .then(res => res.map(s => {
            return { ...s, type: 'cps' };
        }))
}

export function getCelSchoolProfile(schoolId) {
    return fetch(`${EPI_URL}schoolprofile/ECESchoolData?EnrollmentYear=${EnrollmentYear}&schoolCode=${schoolId}`)
        .then(res => res.json())
        .then(res => res[0])
        .then(res => addOriginalCase(res))
}

export function autocompleteSearch(autocompleteItem, mode) {
    let autocompleteSearchEdpoint = `${EPI_URL}v1/search/celautocompletesearch`
    let params = {
        "searchTerm": '',
        "pageSize": 1000,
        "pageNumber": 1,
        "context": "Schools",
        "dateSortRelevanceFilter": 0,
        "contentID": contentId,
        "SearchFieldName": autocompleteItem.fieldName,
        "SearchFieldValue": autocompleteItem.fieldValue,
        "SchoolType": mode == 'gocps' ? 'cps' : 'cel'
    };
    if (mode == 'prog') {
        autocompleteSearchEdpoint = `${EPI_URL}v1/search/summerschoolautocompletesearch`
        delete params.SchoolType;
    }

    return fetch(autocompleteSearchEdpoint, {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
            'Content-Type': 'application/json'
        },
    }).then(res => res.json())
        .then(res => res.results)
}

export function getAllPrekSchools(withProfiles = false): Promise<CelRequest> {
    // Can lazy load the profiles if loading time is an issue, but that endpoint seems fast
    //return Promise.all([getAllPrekSchoolsExistingSearch(), getAllPrekSchoolProfiles()])
    // @TODO finish refactoring to be epi-only
    return Promise.all([getAllPrekSchoolsExistingSearch()])
        .then(res => {
            //const profileRes = res[1];
            return res[0];
            // create a map  and go through and attach epi info
            
        })

}

export function getAllPrekSchoolProfiles() {
    return Promise.all([getAllCelSchools(), getAllEceCpsSchools()])
        // @ts-ignores
        .then(res => {
            return interleave(res[0], res[1]);
        });
}

export function prekFacetRollup(facets: Facet[]): Facet[] {
    let newFacets: Facet[] = []
    for (let facet of facets) {
        let nf = newFacets.filter(f => f.displayName == facet.displayName);
        if (nf.length == 0) {
            newFacets.push({ ...facet, searchFields: [facet.fieldName] });
        } else {
          
            nf[0].terms = [...nf[0].terms, ...facet.terms];
            nf[0].searchFields.push(facet.fieldName);
        }
    }
   
    return newFacets;
}

export function getAllPrekSchoolsExistingSearch() {
    let params = {
        "searchTerm": "",
        "pageSize": 1000,
        "pageNumber": 1,
        "facets": [],
        "context": "Schools",
        "dateSortRelevanceFilter": 0,
        "contentID": contentId
    }

    return fetch(`${EPI_URL}v1/search/celresults`, {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
            'Content-Type': 'application/json'
        },
    }).then(res => res.json())
        .then(res => {
            res.facets = prekFacetRollup(res.facets);
            res.results = res.results.map(s => {
                s.phoneNumber = formatPhone(s.phoneNumber);
                return s;
            })
            return res as CelRequest;
        });
}

